import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth/auth.store';

export type PrivateRoutesProps = {
  children: React.ReactNode;
};

const PrivateRoutes: React.FC<PrivateRoutesProps> = ({ children }) => {
  const token = useAuthStore(s => s.token);

  return !token ? <Navigate to="/auth/login" replace /> : <>{children}</>;
};

export default PrivateRoutes;
